document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(".tee-product-price");
  const insertAfterElement = document.querySelector(
    ".product-info__liquid .price-list"
  );
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }

  let clonedElement = null;
  let hasCloned = false;

  setInterval(() => {
    if (!hasCloned) {
      const elementToMove1 = document.querySelector(".size-chart-button");
      if (elementToMove1) {
        clonedElement = elementToMove1.cloneNode(true);
        hasCloned = true;
        console.log("Cloned element:", clonedElement);
      }
    }

    if (clonedElement) {
      const insertAfterElement1 = document.querySelector(
        ".tee-option--size .tee-option__title"
      );

      if (insertAfterElement1 && !insertAfterElement1.contains(clonedElement)) {
        insertAfterElement1.appendChild(clonedElement);
        console.log("Cloned element inserted.");
      }
    }
  }, 1000);
});
